import type { KlarnaConfig } from '#types/config/components/klarna'
import type { RecursivePartial } from '#types/utils'

export default {
  showInstallmentsInfo: false
} satisfies RecursivePartial<KlarnaConfig>
